import { SuccessResponse } from '../../auth.types'

/** @public Used in the exported demo organization API response. */
export interface DemoOrgId {
  id: number | null
  org_id: number
}

export type GetDemoOrgIdsResponse = SuccessResponse<DemoOrgId[]>
